module.exports = __webpack_public_path__ + "img/svg - parents.f6212546.svg";